<template>
  <!-- Modal on first load and error modals -->
  <div class="modal" v-if="openModal === true" :class="{ visible: openModal }">
    <div
      class="frame visible"
      style="background-image: url('https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/4669/dist/assets/img/background-image.png')"
    >
      <div class="close" @click="closeModal">
        <i class="fa far fa-times"></i>
      </div>

      <!-- Postcode info when user first land -->
      <div class="postcode-info" v-if="modalType === 'postcodeInfo'">
        <div class="details">
          <h2>Find threatened species near you</h2>
          <p>
            Use your address to locate endangered species in your neighbourhood.
          </p>
        </div>
        <i class="fa fa-angle-down" @click="scrollToInput"></i>
      </div>

      <!-- Address error (incorrect) -->
      <div class="error-modal" v-if="isError">
        <div class="logo">
          <div
            class="error-icon"
            style="background-image: url('https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/4669/dist/assets/img/error-icon.png')"
          ></div>
        </div>
        <div class="content">
          <h4>{{ errorText[modalType] }}</h4>
          <button type="button" name="dismiss" @click="closeModal">
            Dismiss
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      errorText: {
        noElectorateError: "Enter your address to find what animals could live near you",
        invalidAddressError: "Your address or postcode can't be shorter than 4 characters.",
        addressNotFoundError: "This address could not be found. Please make sure it is an Australian address.",
      },
    };
  },
  computed: {
    ...mapGetters(["openModal", "modalType"]),
    isError() {
      return this.modalType.endsWith("Error");
    },
  },
  methods: {
    closeModal() {
      this.$store.commit("closeModal");

      if (this.modalType === "postcodeInfo") {
        // Log closed intro
        this.$store.dispatch("logSimpleEvent", {
          eventName: "Intro Panel Close Manual",
          eventProperties: { "Close Panel": true },
        });
      }
    },

    scrollToInput() {
      document.getElementById("search").scrollIntoView({
        alignToTop: "false",
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
    },
  },
};
</script>

<style scoped>
.modal {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 5%;
  left: 25%;
  width: 45%;
  z-index: 100;
}

.modal.visible {
  display: flex;
}

.modal .frame {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
  height: 350px;
  width: 100%;
  max-width: 850px;
  padding: calc(4 * var(--space));
  background-size: 100% 100%;
  background-color: #1c3226;
  background-repeat: no-repeat;
}

.modal .frame h2,
.modal .frame p,
.modal .frame h4,
.modal .frame i {
  color: var(--white);
  margin: 0;
  text-align: center;
}

.modal .frame h4 {
  margin-bottom: 20px;
}

.postcode-info,
.error-modal {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 12px;
}

.postcode-info h4,
.error-modal h4 {
  text-align: center;
}

.postcode-info i {
  cursor: pointer;
}

.modal .frame .close {
  position: absolute;
  top: calc(1.5 * var(--space));
  right: calc(2 * var(--space));
  cursor: pointer;
}

.modal .frame.visible {
  display: flex;
}

.modal .frame .details {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.logo {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 64px;
  height: 64px;
  padding: 8px;
  border-radius: 100px;
  background-color: #dce6cd;
}

.error-icon {
  width: 48px;
  height: 48px;
  background-size: cover;
  background-repeat: no-repeat;
}

button {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 70px;
  font-family: var(--font-secondary);
  font-size: 1.5em;
  color: #fff;
  border-radius: var(--border-radius);
  background-color: var(--wwfRegenerateAustralia);
  cursor: pointer;
  text-transform: uppercase;
  padding: 24px;
  margin: 0;
}

@media screen and (max-width: 1350px) {
  .modal {
    width: 50%;
  }
}

@media screen and (max-width: 1250px) {
  .modal {
    left: 20%;
    width: 60%;
  }

  .modal .frame {
    height: 300px;
  }
}

@media screen and (max-width: 801px) {
  .modal .frame {
    height: 260px;
  }
}

@media screen and (max-width: 700px) {
  .modal {
    left: 15%;
    width: 70%;
  }
}

/* Style from elcom */
h1, h2, h3 {
  font-family: "WWF",sans-serif;
  position: relative;
  z-index: 1;
}

h2 {
  font-size: 50px;
}
@media only screen and (max-width: 64em) {
  h2 {
      font-size: 44px;
      line-height: 46px;
  }
}
@media only screen and (max-width: 40em) {
  h2 {
    font-size: 34px;
    line-height: 36px;
  }
}

h4 {
  font-family: 'Lato',sans-serif;
  font-weight: 600;
  font-size: 26;
}

p {
  font-family: 'Lato',sans-serif;
  position: relative;
  margin: 0;
  font-size: 16px;
}

@media only screen and (max-width: 40em) {
  p {
    font-size: 15px;
    line-height: 23px;
  }
}
/* END */
</style>


// WEBPACK FOOTER //
// ThreatenedSpeciesModal.vue?696ed5e1